import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, ChevronUpIcon, FacebookIcon, InstagramIcon, LockIcon, MailIcon, ShieldCheckIcon, XCircleIcon, ZapIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://cupping-estetico.impultienda.ar/checkout';
const faqs = [['¿Sirve si recién estoy empezando con ventosas estéticas?', 'Sí. Cada protocolo está explicado paso a paso, desde la anatomía de la zona hasta el movimiento exacto. No necesitás experiencia previa con ventosas para empezar a aplicar los tomos desde el día uno.'], ['¿Sirve si ya soy esteticista con experiencia?', 'Especialmente. La Maestría en Ventosas Estéticas™ te da la estructura profesional y el material de cabina que probablemente te faltaba: fichas, checklists, mapas de zonas y protocolos avanzados que podés incorporar a tus sesiones actuales de inmediato.'], ['¿Cómo recibo el material?', 'Descarga inmediata en PDF apenas confirmás la compra. Lo abrís en computadora, tablet o celular, y podés imprimir todo lo que necesites para tu cabina.'], ['¿Qué ventosas necesito tener para usar los protocolos?', 'El Bono 01 incluye el Mapa Express de Ventosas por Zona con las especificaciones de tamaño e intensidad para cada protocolo. No necesitás un kit costoso para empezar.'], ['¿El material está en español neutro?', 'Sí. Todo el sistema está escrito en español neutro para que sea útil para esteticistas de Argentina, México, Colombia, España, Chile, Venezuela, Perú y todo el mundo hispanohablante.'], ['¿Puedo usar el material con mi marca?', 'Las fichas de evaluación y el material de seguimiento están diseñados para que les agregues tu logo y los uses como material profesional de tu cabina.'], ['¿Esto es un curso con clases en video?', 'No. Es un sistema completo en PDF listo para usar. Abrís el tomo, elegís el protocolo y lo aplicás. Cero teoría de relleno.'], ['¿Y si no me sirve?', 'Garantía de 7 días con devolución total, sin preguntas.']];
const valueRows = [['Sesiones sin protocolo estructurado', 'Resultados inconsistentes — clientas que no vuelven', 'Protocolos claros por zona', 'Resultados visibles — clientas que vuelven y refieren'], ['Técnica improvisada por zona', 'Confianza baja — precio bajo', 'Técnica estructurada paso a paso', 'Confianza alta — precio que se justifica solo'], ['Buscar tutoriales en YouTube', 'Información contradictoria, en inglés o sin base técnica', 'Sistema completo en español', 'Información técnica, probada y lista para usar'], ['Sin diferenciación de la competencia', 'Tu cabina se ve igual que todas las demás', 'Material profesional de cabina', 'Tu servicio se percibe premium desde el primer momento'], ['Sin justificación para cobrar más', 'Seguís cobrando lo mismo hace años', 'Metodología de 6 tomos', 'Tenés el respaldo para cobrar lo que realmente valés'], ['Sin material profesional de seguimiento', 'La clienta no ve su progreso y abandona', 'Fichas de seguimiento y agenda', 'La clienta ve su evolución y renueva']];
const costRows = [['Sesiones sin estructura clara', 'Clientas que no ven resultados y no vuelven — perdés $80 a $200 por clienta'], ['Sin diferenciación profesional', 'Siempre compitiendo por precio con quien cobra menos'], ['Sin material de cabina premium', 'Tu servicio parece igual al de cualquier otra esteticista'], ['Sin protocolos avanzados', 'Nunca podés justificar subir tus precios'], ['Sin sistema de seguimiento', 'La clienta no ve su progreso y abandona antes de tiempo']];
const testimonials = [['El Tomo V es el que más me pidieron mis clientas. El Brazilian Lift con ventosas es ahora el tratamiento estrella de mi cabina. Lista de espera de tres semanas.', 'Esteticista certificada · Colombia'], ['Las fichas de seguimiento cambiaron la percepción de mis clientas. Ahora ven su progreso documentado. Tres de cada cuatro renuevan el tratamiento.', 'Cosmetóloga · Chile'], ['Compré la Maestría en Ventosas Estéticas™ un viernes. El lunes ya apliqué el protocolo de drenaje linfático. Mi clienta me preguntó qué había cambiado. Le dije: mi método.', 'Esteticista independiente · España'], ['Lo que más uso antes de cada sesión es el Mapa Express de Ventosas. En 30 segundos ya sé qué usar. Eso solo ya vale el precio completo.', 'Masajista estética · México'], ['Subí mis precios tres semanas después de empezar a usar los protocolos. Mis clientas no solo no se quejaron — me felicitaron por el nivel del servicio.', 'Esteticista · Venezuela'], ['El protocolo de cuello del Tomo II es el que más wow genera. Las clientas se miran al espejo y no lo pueden creer. Eso es lo que hace que vuelvan.', 'Terapeuta estética · Perú']];
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 34
  });
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return current;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const clock = `${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;
  return <div className="w-full bg-cream" data-id="element-118">
      <section className="bg-brand-900 px-4 py-11 text-center text-white sm:px-6" aria-label="Oferta de lanzamiento" data-id="element-119">
        <p className="text-xs font-black tracking-[0.12em] text-accent" data-id="element-120">
          🛑 PRECIO DE LANZAMIENTO — CIERRA EN:
        </p>
        <p aria-live="polite" className="mt-3 font-mono text-4xl font-black tracking-tight text-white sm:text-6xl" data-id="element-121">
          {clock}
        </p>
        <p className="mt-3 text-sm text-gray-300" data-id="element-122">
          ⚠️ Después sube a $37. No vuelve.
        </p>
        <div className="mx-auto mt-5 h-2 max-w-md overflow-hidden rounded-full bg-brand-800" data-id="element-123">
          <div className="h-full w-[91%] rounded-full bg-accent" data-id="element-124" />
        </div>
        <p className="mt-2 text-xs text-brand-100" data-id="element-125">
          El 91% de los accesos al precio de lanzamiento ya fueron reservados
        </p>
      </section>

      <section id="pricing" className="mx-auto max-w-6xl scroll-mt-4 px-4 py-12 sm:px-6 md:py-20" data-id="element-126">
        <div className="text-center" data-id="element-127">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-128">
            Tu Maestría en Ventosas Estéticas™ completa
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-129">
            Todos tus protocolos de ventosas resueltos
          </h2>
        </div>
        <div className="mx-auto mt-9 max-w-2xl" data-id="element-130">
          <article className="flex flex-col rounded-2xl border border-brand-100 bg-white p-6 text-center shadow-sm md:p-8" data-id="element-131">
            <p className="text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-132">
              MAESTRÍA EN VENTOSAS ESTÉTICAS™ — SISTEMA COMPLETO
            </p>
            <h3 className="mt-2 text-2xl font-black text-brand-900" data-id="element-133">
              6 Tomos + 5 Bonos
            </h3>
            <p className="mt-2 text-sm text-gray-600" data-id="element-134">
              Todos tus protocolos de ventosas resueltos.
            </p>
            <ul className="mt-6 space-y-3 text-left text-sm text-gray-700" data-id="element-135">
              {['6 tomos completos con 360+ páginas', '5 bonos estratégicos incluidos', 'Protocolos, fichas y checklists imprimibles'].map(item => <li key={item} className="flex gap-2" data-id="element-136">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-500" data-id="element-137" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-7 text-center" data-id="element-138">
              <p data-id="element-139">
                <span className="mr-2 text-lg text-gray-400 line-through" data-id="element-140">
                  $37 USD
                </span>
                <strong className="font-black text-brand-900 text-[80px]" data-id="element-141">
                  $14
                </strong>{' '}
                <span className="font-bold text-brand-600" data-id="element-142">USD</span>
              </p>
              <p className="mt-1 text-xs text-gray-500" data-id="element-143">
                El producto se cobrará en moneda local.
              </p>
            </div>
            <a href={CHECKOUT_URL} className="mt-5 block rounded-xl border-2 border-brand-600 px-4 py-3.5 text-center text-sm font-extrabold text-brand-700 transition-colors hover:bg-brand-50" data-id="element-144">
              SÍ, QUIERO MI MAESTRÍA EN VENTOSAS ESTÉTICAS™
            </a>
            <p className="mt-4 flex flex-wrap justify-center gap-x-3 gap-y-1 text-xs text-gray-500" data-id="element-145">
              <span className="flex items-center gap-1" data-id="element-146">
                <LockIcon className="h-3.5 w-3.5" data-id="element-147" />
                Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-148">
                <ZapIcon className="h-3.5 w-3.5" data-id="element-149" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-150">
                <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-151" />
                Garantía de 7 días
              </span>
            </p>
          </article>
        </div>
      </section>

      <section className="bg-white px-4 py-12 sm:px-6 md:py-20" data-id="element-152">
        <div className="mx-auto max-w-6xl" data-id="element-153">
          <div className="text-center" data-id="element-154">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-155">
              Comparativa de valor
            </p>
            <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-156">
              💸 ¿Cuánto cuesta seguir sin un sistema?
            </h2>
          </div>
          <div className="mt-9 overflow-x-auto rounded-xl border border-brand-100" data-id="element-157">
            <table className="min-w-[840px] w-full text-left text-sm" data-id="element-158">
              <thead data-id="element-159">
                <tr className="bg-cream" data-id="element-160">
                  <th colSpan={2} className="border-r border-brand-100 p-4 text-brand-900" data-id="element-161">
                    ❌ Sin Maestría en Ventosas Estéticas™
                  </th>
                  <th colSpan={2} className="p-4 text-brand-700" data-id="element-162">
                    ✅ Con Maestría en Ventosas Estéticas™
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-163">
                {valueRows.map(([without, cost, withSystem, result]) => <tr key={without} className="border-t border-brand-100" data-id="element-164">
                    <td className="p-4 font-semibold text-gray-700" data-id="element-165">
                      {without}
                    </td>
                    <td className="border-r border-brand-100 p-4 text-gray-500" data-id="element-166">
                      {cost}
                    </td>
                    <td className="p-4 font-semibold text-brand-800" data-id="element-167">
                      {withSystem}
                    </td>
                    <td className="p-4 text-brand-700" data-id="element-168">{result}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-169">
        <div className="text-center" data-id="element-170">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-171">
            Más testimonios
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-172">
            Una nueva forma de trabajar se nota
          </h2>
        </div>
        <div className="mt-9 grid gap-4 sm:grid-cols-2 md:grid-cols-3" data-id="element-173">
          {testimonials.map(([quote, role]) => <article key={quote} className="rounded-xl border border-brand-100 bg-white p-5" data-id="element-174">
              <p className="text-xs font-bold text-accent" data-id="element-175">★★★★★</p>
              <blockquote className="mt-2 text-sm leading-relaxed text-gray-700" data-id="element-176">
                “{quote}”
              </blockquote>
              <p className="mt-4 text-xs font-bold text-brand-700" data-id="element-177">{role}</p>
            </article>)}
        </div>
        <p className="mt-5 text-center text-xs text-gray-500" data-id="element-178">
          Testimonios de lanzamiento. Se reemplazarán por opiniones verificadas
          de compradoras.
        </p>
      </section>

      <section className="bg-brand-50 px-4 py-12 sm:px-6" data-id="element-179">
        <div className="mx-auto max-w-3xl rounded-3xl border-2 border-brand-100 bg-white p-7 text-center shadow-sm md:p-10" data-id="element-180">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-brand-600" data-id="element-181" />
          <h2 className="mt-4 text-3xl font-black text-brand-900" data-id="element-182">
            GARANTÍA DE 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="mt-4 leading-relaxed text-gray-600" data-id="element-183">
            Abrí los tomos. Aplicá los protocolos. Mirá los resultados.
          </p>
          <p className="mt-2 leading-relaxed text-gray-600" data-id="element-184">
            Si en 7 días no es lo que esperabas: te devolvemos el 100% de tu
            inversión, sin formularios, sin explicaciones y sin complicaciones.
          </p>
          <p className="mt-5 text-sm font-bold text-brand-600" data-id="element-185">
            Porque estamos seguros de lo que entregamos.
          </p>
        </div>
      </section>

      <section className="bg-white px-4 py-12 sm:px-6 md:py-20" data-id="element-186">
        <div className="mx-auto max-w-3xl" data-id="element-187">
          <h2 className="text-center text-3xl font-black text-brand-900" data-id="element-188">
            Preguntas frecuentes
          </h2>
          <div className="mt-8 space-y-3" data-id="element-189">
            {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return <div key={question} className="overflow-hidden rounded-xl border border-gray-200" data-id="element-190">
                  <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-cream px-5 py-4 text-left text-sm font-bold text-brand-900" data-id="element-191">
                    {question}
                    {isOpen ? <ChevronUpIcon className="h-5 w-5 shrink-0" data-id="element-192" /> : <ChevronDownIcon className="h-5 w-5 shrink-0" data-id="element-193" />}
                  </button>
                  {isOpen && <div className="bg-white px-5 py-4 text-sm leading-relaxed text-gray-600" data-id="element-194">
                      {answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="bg-brand-900 px-4 py-12 text-white sm:px-6 md:py-20" data-id="element-195">
        <div className="mx-auto max-w-6xl text-center" data-id="element-196">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-accent" data-id="element-197">
            El costo real de seguir sin un sistema profesional
          </p>
          <h2 className="mt-3 text-3xl font-black md:text-4xl" data-id="element-198">
            💸 ¿Cuánto cuesta no tenerlo?
          </h2>
          <div className="mt-8 overflow-x-auto rounded-xl border border-brand-700 text-left" data-id="element-199">
            <table className="min-w-[650px] w-full text-sm" data-id="element-200">
              <thead data-id="element-201">
                <tr className="bg-brand-800" data-id="element-202">
                  <th className="p-4" data-id="element-203">Sin Maestría en Ventosas Estéticas™</th>
                  <th className="p-4" data-id="element-204">Costo real</th>
                </tr>
              </thead>
              <tbody data-id="element-205">
                {costRows.map(([without, cost]) => <tr key={without} className="border-t border-brand-700" data-id="element-206">
                    <td className="p-4 text-brand-100" data-id="element-207">{without}</td>
                    <td className="p-4 font-semibold text-white" data-id="element-208">{cost}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="mt-8 text-brand-100" data-id="element-209">
            Tu próxima clienta puede vivir una experiencia completamente
            diferente.
          </p>
          <p className="mt-5 font-serif text-2xl italic text-accent" data-id="element-210">
            “Tu próxima sesión puede ser la mejor que diste.”
          </p>

          <div className="mx-auto mt-10 max-w-4xl rounded-3xl bg-white p-7 text-brand-900 md:p-10" data-id="element-211">
            <h3 className="text-3xl font-black" data-id="element-212">
              Dejá de improvisar. Empezá a trabajar con un sistema.
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-gray-600" data-id="element-213">
              Sumate a las esteticistas que ya aplican protocolos profesionales,
              cobran lo que valen y tienen clientas que vuelven sesión tras
              sesión.
            </p>
            <p className="mt-5 text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-214">
              PROTOCOLOS. MAPAS. FICHAS. CHECKLISTS. GUÍAS. TODO RESUELTO.
            </p>
            <div className="mt-6 overflow-x-auto rounded-xl border border-brand-100 text-left" data-id="element-215">
              <table className="min-w-[620px] w-full text-sm" data-id="element-216">
                <thead data-id="element-217">
                  <tr className="bg-cream" data-id="element-218">
                    <th className="p-4 text-gray-600" data-id="element-219">
                      ❌ Sin Maestría en Ventosas Estéticas™
                    </th>
                    <th className="p-4 text-brand-700" data-id="element-220">
                      ✅ Con Maestría en Ventosas Estéticas™
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-221">
                  {[['Improvisás zona por zona', 'Protocolo claro para cada zona del cuerpo'], ['Resultados inconsistentes', 'Resultados visibles que tus clientas perciben'], ['Clientas que abandonan', 'Tratamientos que renuevan'], ['Precio que no podés justificar', 'Sistema profesional que habla por vos'], ['Buscando tutoriales en YouTube', '360 páginas de protocolos listos en tu cabina']].map(([without, withSystem]) => <tr key={without} className="border-t border-brand-100" data-id="element-222">
                      <td className="p-3.5 text-gray-600" data-id="element-223">{without}</td>
                      <td className="p-3.5 font-semibold text-brand-800" data-id="element-224">
                        {withSystem}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <p className="mt-7 text-xs font-bold tracking-wider text-brand-600" data-id="element-225">
              ⏰ EL PRECIO CIERRA EN: {clock}
            </p>
            <p className="mt-2 text-base font-bold" data-id="element-226">
              MAESTRÍA EN VENTOSAS ESTÉTICAS™ — $14 USD ⭐
            </p>
            <a href={CHECKOUT_URL} className="mt-6 block rounded-xl bg-brand-600 px-5 py-4 text-sm font-extrabold text-white transition-colors hover:bg-brand-700" data-id="element-227">
              SÍ, QUIERO MI MAESTRÍA AHORA
            </a>
            <p className="mt-4 text-xs text-gray-500" data-id="element-228">
              🔒 Pago 100% seguro · ⚡ Acceso inmediato · 🛡️ Garantía de 7 días
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-[#102015] px-4 py-10 text-center text-sm text-gray-400 sm:px-6" data-id="element-229">
        <div className="mx-auto max-w-4xl" data-id="element-230">
          <p className="font-bold text-white" data-id="element-231">
            MAESTRÍA EN VENTOSAS ESTÉTICAS™
          </p>
          <p className="mx-auto mt-3 max-w-xl leading-relaxed" data-id="element-232">
            El sistema #1 de protocolos de ventosas estéticas en español. Porque
            una esteticista profesional no debería improvisar nunca más.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-233">
            <a href="mailto:soporte@tuproximonivel.com" className="flex items-center gap-2 hover:text-white" data-id="element-234">
              <MailIcon className="h-4 w-4" data-id="element-235" />
              soporte@tuproximonivel.com
            </a>
            <a href="https://www.instagram.com/tuproximonivel216/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-236">
              <InstagramIcon className="h-4 w-4" data-id="element-237" />
              @tuproximonivel
            </a>
            <a href="https://www.facebook.com/profile.php?id=61555374626740" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-238">
              <FacebookIcon className="h-4 w-4" data-id="element-239" />
              Facebook
            </a>
          </div>
          <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs" data-id="element-240">
            <a href="#terms" className="hover:text-white" data-id="element-241">
              Términos y condiciones
            </a>
            <a href="#privacy" className="hover:text-white" data-id="element-242">
              Política de privacidad
            </a>
          </div>
          <p className="mt-7 text-xs" data-id="element-243">
            TU PRÓXIMO NIVEL™ — Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}